import { filterClasses } from "@swivl-mono/helpers";
import * as React from "react";
import { IoMdCheckmark, IoMdClose } from "react-icons/io";

import "./Switch.scss";

export enum SwitchVariant {
  DEFAULT = "default",
  TOGGLE = "toggle"
}

interface Props {
  on: boolean;
  onChange?: (event: any) => void;
  onSet?: (on: boolean, name?: string) => void;
  className?: string;
  name?: string;
  analytics?: any;
  children?: any;
  id?: string;
  isInRightCol?: boolean;
  readOnly?: boolean;
  label?: string;
  isDisabled?: boolean;
  readOnlyHoverOverlay?: string;
  variant?: SwitchVariant;
  /** TOGGLE on-state color; default teal. */
  activeColor?: "teal" | "black" | "orange";
}

export class Switch extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick() {
    if (this.props.onSet) {
      this.props.onSet(!this.props.on, this.props.name);
    }
    if (this.props.onChange) {
      const event = { target: { value: !this.props.on, checked: !this.props.on, type: "checkbox", name: this.props.name } };
      // if (this.props.analytics && this.props.analytics.category) {
      //   if (!this.props.on &&  this.props.analytics.onAction) {    window.AnalyticsEvent(this.props.analytics.category,  this.props.analytics.onAction);
      //   } else if (this.props.on &&  this.props.analytics.offAction) { window.AnalyticsEvent(this.props.analytics.category,  this.props.analytics.offAction); }
      // }

      this.props.onChange(event);
    }
  }
  render() {
    const { readOnlyHoverOverlay, on, readOnly, isDisabled, label, variant, activeColor } = this.props;

    if (variant === SwitchVariant.TOGGLE) {
      const isInteractive = !(readOnly || isDisabled);
      const palette = {
        teal: { on: "bg-teal-800", off: "bg-grey-600", onHover: "hover:bg-teal-900", offHover: "hover:bg-grey-700" },
        black: { on: "bg-grey-900", off: "bg-grey-300", onHover: "hover:bg-grey-800", offHover: "hover:bg-grey-400" },
        orange: { on: "bg-orange-500", off: "bg-grey-300", onHover: "hover:bg-orange-600", offHover: "hover:bg-grey-400" }
      }[activeColor ?? "teal"];
      // Hide off "X" on light tracks.
      const showOffIcon = (activeColor ?? "teal") === "teal";
      return (
        <div className="flex flex-row items-center">
          <button
            type="button"
            className={filterClasses(
              "relative flex h-6 w-12 items-center rounded-full shadow-[inset_0px_1px_1px_rgba(0,0,0,0.25)] transition-colors duration-300",
              on ? palette.on : palette.off,
              isInteractive && (on ? palette.onHover : palette.offHover),
              isDisabled ? "cursor-not-allowed" : "cursor-pointer"
            )}
            onClick={isInteractive ? this.onClick : undefined}
            disabled={isDisabled}
          >
            <span
              className={filterClasses(
                "absolute top-1 flex size-4 items-center justify-center text-white transition-opacity duration-300",
                on ? "left-[5px] opacity-100" : "left-[5px] opacity-0"
              )}
            >
              <IoMdCheckmark size={16} />
            </span>
            <span
              className={filterClasses(
                "absolute top-0.5 size-5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.3)] transition-all duration-300",
                on ? "left-[26px]" : "left-0.5"
              )}
            />
            {showOffIcon && (
              <span
                className={filterClasses(
                  "absolute top-1 flex size-4 items-center justify-center text-white transition-opacity duration-300",
                  on ? "right-[5px] opacity-0" : "right-[5px] opacity-100"
                )}
              >
                <IoMdClose size={16} />
              </span>
            )}
          </button>
          {label && <div className="switchLabel">{label}</div>}
        </div>
      );
    }
    let className = this.props.className ? this.props.className + " ssSwitch" : "ssSwitch";

    if (on) {
      className += " on";
    }
    if (readOnly) {
      className += " readOnly";
    }
    if (isDisabled) {
      className += " disabled";
    }
    if (!(readOnly || isDisabled)) {
      className += " selectable";
      return (
        <div className="flex flex-row">
          <div className={className} id={this.props.id} onClick={this.onClick}>
            <div className="indicator"></div>
            <div className="onLabel">ON</div>
            <div className="offLabel">OFF</div>
          </div>
          {label && <div className="switchLabel">{label}</div>}
        </div>
      );
    } else {
      return (
        <div className="flex flex-row">
          <div className={className}>
            <div className="indicator"></div>
            <div className="onLabel">ON</div>
            <div className="offLabel">OFF</div>
            {readOnlyHoverOverlay && <div className="readOnlyHoverOverlay">{readOnlyHoverOverlay}</div>}
          </div>
          {label && <div className="switchLabel readOnlyLabel">{label}</div>}
        </div>
      );
    }
  }

  //   if (this.props.readOnly || this.props.isDisabled) {
  //     const className = (this.props.on) ? "ssSwitch readOnly on": "readOnly ssSwitch";
  //     return <div className={className}>
  //             <div className="readOnlyLabel">{this.props.on ? "ON" : "OFF"}</div>
  //           </div>;
  //   }

  //   const className = (this.props.on) ? "ssSwitch selectable on": "selectable ssSwitch";
  //   if (this.props.label) {
  //     return <div className="flex flex-row">
  //             <div className={className} onClick={this.onClick}>
  //               <div className="indicator"></div>
  //               <div className="onLabel">ON</div>
  //               <div className="offLabel">OFF</div>
  //             </div>
  //             <div className="switchLabel">{this.props.label}</div>
  //     </div>
  //   }

  //   return <div className={className} onClick={this.onClick}>
  //           <div className="indicator"></div>
  //           <div className="onLabel">ON</div>
  //           <div className="offLabel">OFF</div>
  //         </div>;
  //  }
}
